import "./NftSelectOption.scss";

import React, { FC } from "react";

import { IDetailNftData } from "../../../../../../../common/interfaces/common.interface";
import { ITradeInfo } from "../../../../../../../common/interfaces/proposals.interface";
import { getMintDecimalsDivider } from "../../../../../../../utilities/helpers";

const NftSelectOption: FC<{
  nft: IDetailNftData;
  isOptionDisabled?: boolean;
  tradeInfo?: ITradeInfo;
}> = ({ nft, isOptionDisabled, tradeInfo }) => {
  return (
    <div className={`nft-option ${isOptionDisabled && "nft-option--disabled"}`}>
      <div className="nft-option__info">
        <img src={nft.nftUrl} alt="nft__image" className="nft-option__image" />
        <div className="nft-option__description">
          <p className="nft-option__nft-name">{nft.name}</p>
          {nft.collection && (
            <p className="nft-option__nft-collection">
              by {nft.collection.name}
            </p>
          )}
          {nft.universeRarity && (
            <p className="nft-option__nft-rarity">
              Rarity:{" "}
              <span className={`nft-option__nft-rarity--${nft.universeRarity}`}>
                {nft.universeRarity}
              </span>
            </p>
          )}
        </div>
      </div>
      {tradeInfo && (
        <div className="nft-option__trade-info">
          <p className="nft-option__trade-info-label">Bought price</p>
          <p className="nft-option__trade-info-price">
            {tradeInfo.price / getMintDecimalsDivider(tradeInfo.mintDecimals)}{" "}
            {tradeInfo.mintSymbol}
          </p>
        </div>
      )}
    </div>
  );
};

export default NftSelectOption;
